/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

document.addEventListener('DOMContentLoaded', function() {
  const GO_TO_CART_TEXT = 'VIEW CART';
  const CART_ICON_SVG = '<svg class="go-to-cart-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>';
  const INNOVIST_ATC_ICON_SVG = '<svg class="innovist-cart-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="20" r="1.5" fill="#111111"/><circle cx="17.5" cy="20" r="1.5" fill="#111111"/><path d="M2 3H4.5L7.2 15C7.3 15.6 7.8 16 8.4 16H18.2C18.8 16 19.3 15.6 19.4 15L21.5 7H5.5" stroke="#111111" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M18.5 1.5V4.5M17 3H20" stroke="#FF5E62" stroke-width="2" stroke-linecap="round"/></svg>';
  let currentCartItems = [];

  function getVariantId(element) {
    const form = element.closest('form');
    if (form) {
      const idInput = form.querySelector('input[name="id"], select[name="id"]');
      if (idInput) return idInput.value;
    }
    const id = element.getAttribute('data-variant-id') || element.getAttribute('data-id') || element.getAttribute('data-product-id');
    if (id) return id;
    const parent = element.parentElement;
    if (parent) {
      const idInput = parent.querySelector('input[name="id"]');
      if (idInput) return idInput.value;
    }
    return null;
  }

  function isProductCardButton(btn) {
    if (btn.classList.contains('product-item__cta') || btn.classList.contains('product-card__cta')) return true;
    if (btn.closest('.product-item, .meta-product-item, .product-card, .cstm-prd-lst, .product-list, .collection, .product-facet__product-list')) return true;
    return false;
  }

  window.openGlobalCartDrawer = function(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    const cartToggle = document.querySelector('[aria-controls="mini-cart"], .header__cart-toggle, a[href="/cart"]');
    if (cartToggle && cartToggle.getAttribute('aria-controls') === 'mini-cart') {
      cartToggle.click();
    } else {
      window.location.href = '/cart';
    }
  };

  function updateStickyCartBar(cart) {
    const bar = document.getElementById('InnovistStickyCartBar');
    if (!bar) return;
    
    let count = 0;
    let total = 0;

    if (cart && typeof cart.item_count === 'number') {
      count = cart.item_count;
      total = cart.total_price;
    } else if (currentCartItems && currentCartItems.length > 0) {
      count = currentCartItems.reduce((acc, i) => acc + (i.quantity || 0), 0);
      total = currentCartItems.reduce((acc, i) => acc + (i.final_line_price || i.line_price || (i.price * i.quantity) || 0), 0);
    }

    if (count > 0) {
      bar.style.setProperty('display', 'block', 'important');
      const totalEl = bar.querySelector('[data-cart-bar-total]');
      const countEl = bar.querySelector('[data-cart-bar-count]');
      if (totalEl) {
        totalEl.textContent = '₹' + Math.round(total / 100).toLocaleString('en-IN');
      }
      if (countEl) {
        countEl.textContent = count + (count === 1 ? ' item' : ' items');
      }
    } else {
      bar.style.setProperty('display', 'none', 'important');
    }
  }

  function applyCartLogicToButton(btn, itemsInCart, cartItems) {
    // If it is a product card on homepage/collection listing, keep it as ADD TO CART
    if (isProductCardButton(btn)) {
      return;
    }

    const variantId = getVariantId(btn);
    if (!variantId) return;
    
    const allItems = cartItems || currentCartItems || [];
    const cartItem = allItems.find(item => String(item.variant_id || item.id) === String(variantId));
    const isInCart = Boolean(cartItem && cartItem.quantity > 0);
    const itemQuantity = isInCart ? cartItem.quantity : 0;
    const form = btn.closest('form');

    // Find any quantity pill in the form or nearby container
    const container = btn.closest('.foxtale-sticky-form-wrap, .product-form__cta-row, .mobile-sticky-atc__container, form, .product-form, .product-sticky-form') || (form ? form.parentElement : null);
    const qtyPills = container ? container.querySelectorAll('.foxtale-sticky-qty-pill, .product-form__qty-selector, .mobile-sticky-atc__qty-box') : [];

    if (isInCart) {
      if (!btn.hasAttribute('data-original-html')) {
        btn.setAttribute('data-original-html', btn.innerHTML);
      }

      btn.setAttribute('type', 'button');
      btn.classList.add('go-to-cart-btn');
      
      if (!btn.dataset.cartRedirectBound) {
        btn.addEventListener('click', function(e) {
          if (btn.classList.contains('go-to-cart-btn')) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            var cartToggle = document.querySelector('[aria-controls="mini-cart"]');
            if (cartToggle) {
              cartToggle.click();
            } else {
              window.location.href = '/cart';
            }
          }
        }, true);
        btn.dataset.cartRedirectBound = 'true';
      }
      
      btn.innerHTML = CART_ICON_SVG + '<span>' + GO_TO_CART_TEXT + '</span>';

      if (form) {
        form.setAttribute('data-cart-form', 'true');
        form.setAttribute('action', '/cart');
        form.setAttribute('method', 'get');
      }

      // Show quantity pill and set input value to actual cart quantity
      qtyPills.forEach(pill => {
        pill.style.setProperty('display', 'inline-flex', 'important');
        const input = pill.querySelector('input[name="quantity"], .foxtale-sticky-qty-input');
        if (input) input.value = itemQuantity;
        const valEl = pill.querySelector('.foxtale-sticky-qty-val, .product-form__qty-val, [data-sticky-qty]');
        if (valEl) {
          if (valEl.tagName === 'INPUT') valEl.value = itemQuantity;
          else valEl.textContent = itemQuantity;
        }
      });
    } else {
      if (btn.classList.contains('go-to-cart-btn') || btn.hasAttribute('data-original-html')) {
        btn.setAttribute('type', 'submit');
        btn.classList.remove('go-to-cart-btn');
        btn.onclick = null;
        
        if (btn.hasAttribute('data-original-html')) {
          btn.innerHTML = btn.getAttribute('data-original-html');
        } else {
          btn.innerHTML = INNOVIST_ATC_ICON_SVG + '<span>Add to Cart</span>';
        }
        
        if (form && form.getAttribute('action') === '/cart') {
           form.setAttribute('action', '/cart/add');
           form.setAttribute('method', 'post');
        }
      }

      // Hide quantity pill and reset to 1
      qtyPills.forEach(pill => {
        pill.style.setProperty('display', 'none', 'important');
        const input = pill.querySelector('input[name="quantity"], .foxtale-sticky-qty-input');
        if (input) input.value = 1;
        const valEl = pill.querySelector('.foxtale-sticky-qty-val, .product-form__qty-val, [data-sticky-qty]');
        if (valEl) {
          if (valEl.tagName === 'INPUT') valEl.value = 1;
          else valEl.textContent = '1';
        }
      });
    }
  }

  function updateAllCartButtons(cartItems) {
    if (cartItems) {
      currentCartItems = cartItems;
    }
    const itemsInCart = currentCartItems.map(item => item.variant_id || item.id).map(String);
    
    // 1. Update all Product Cards (Mamaearth / Innovist style quantity pill on cards)
    const cardForms = document.querySelectorAll('.product-item, .meta-product-item, .product-card, .cstm-prd-lst, .product-facet__product-list, form[action*="/cart/add"]');
    cardForms.forEach(card => {
      const cardBtn = card.querySelector('.product-item__cta, .product-card__cta');
      const cardPill = card.querySelector('.card-qty-pill, [data-card-qty-pill]');
      if (!cardBtn || !cardPill) return;

      const variantId = getVariantId(card) || card.querySelector('input[name="id"]')?.value;
      if (!variantId) return;

      const cartItem = currentCartItems.find(item => String(item.variant_id || item.id) === String(variantId));
      const isInCart = Boolean(cartItem && cartItem.quantity > 0);
      const itemQty = isInCart ? cartItem.quantity : 0;

      if (isInCart) {
        cardBtn.style.setProperty('display', 'none', 'important');
        cardPill.style.setProperty('display', 'flex', 'important');
        const valEl = cardPill.querySelector('.card-qty-val, [data-card-qty]');
        if (valEl) valEl.textContent = itemQty;
      } else {
        cardBtn.style.removeProperty('display');
        cardPill.style.setProperty('display', 'none', 'important');
        const valEl = cardPill.querySelector('.card-qty-val, [data-card-qty]');
        if (valEl) valEl.textContent = '1';
      }
    });

    // 2. Update Main PDP buttons (product page sticky bar and main ATC button)
    const pdpButtons = document.querySelectorAll('button.foxtale-sticky-atc, button#AddToCart, .mobile-sticky-btn');
    pdpButtons.forEach(btn => {
      applyCartLogicToButton(btn, itemsInCart, currentCartItems);
    });

    const forms = document.querySelectorAll('form[action*="/cart/add"], form[data-cart-form="true"], .foxtale-sticky-form-wrap');
    forms.forEach(form => {
      if (!form.closest('.product-item, .meta-product-item, .product-card, .cstm-prd-lst, .product-list, .collection, .product-facet__product-list')) {
        const btns = form.querySelectorAll('button[type="submit"], button[type="button"].go-to-cart-btn, input[type="submit"], .foxtale-sticky-atc, #AddToCart');
        btns.forEach(btn => applyCartLogicToButton(btn, itemsInCart, currentCartItems));
      }
    });

    updateStickyCartBar();
  }

  function fetchAndCheckCart() {
    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(res => res.json())
      .then(cart => {
        updateAllCartButtons(cart.items);
        updateStickyCartBar(cart);
        
        // Update all cart count bubbles in the header/toolbar
        const countElements = document.querySelectorAll('cart-count, .cart-count, .bubble-count, .header__cart-count, .item-count');
        countElements.forEach(el => {
          el.textContent = cart.item_count;
        });
      })
      .catch(e => console.error(e));
  }

  fetchAndCheckCart();

  document.addEventListener('cart:updated', function(event) {
    if (event.detail && event.detail.cart) {
      updateAllCartButtons(event.detail.cart.items);
      updateStickyCartBar(event.detail.cart);
    } else {
      fetchAndCheckCart();
    }
  });
  
  document.addEventListener('variant:added', function(event) {
    fetchAndCheckCart();
  });

  document.documentElement.addEventListener('cart:refresh', function(event) {
    if (event.detail && event.detail.cart) {
      updateAllCartButtons(event.detail.cart.items);
      updateStickyCartBar(event.detail.cart);
    } else {
      fetchAndCheckCart();
    }
  });
  
  document.addEventListener('variant:changed', function(e) {
    fetchAndCheckCart();
    if (e && e.detail && e.detail.variant) {
      updateFlatDiscountBadge(e.detail.variant.price);
    }
  });

  function updateFlatDiscountBadge(priceInCents) {
    const badges = document.querySelectorAll('.flat-discount-badge--pdp[data-flat-discount-badge]');
    badges.forEach(badge => {
      const priceRupees = Math.round(priceInCents / 100);
      let discount = 0;
      let code = '';
      if (priceRupees > 0 && priceRupees <= 999) {
        discount = 10;
        code = 'FLAT10';
      } else if (priceRupees >= 1000 && priceRupees <= 1499) {
        discount = 20;
        code = 'FLAT20';
      } else if (priceRupees >= 1500) {
        discount = 30;
        code = 'FLAT30';
      }

      if (discount > 0) {
        const discountedRupees = Math.round(priceRupees * (100 - discount) / 100);
        const priceEl = badge.querySelector('.flat-discount-badge__price');
        const codeEl = badge.querySelector('.flat-discount-badge__code');
        if (priceEl) priceEl.textContent = '₹' + discountedRupees;
        if (codeEl) codeEl.textContent = code;
        badge.style.display = 'block';
      } else {
        badge.style.display = 'none';
      }
    });
  }

  let toastObserver = null;
  function startToastObserver() {
    if (toastObserver) toastObserver.disconnect();
    
    toastObserver = new MutationObserver((mutations) => {
      for (let m of mutations) {
        let targetNode = null;
        if (m.type === 'childList') {
          for (let node of m.addedNodes) {
            if (node.nodeType === 1) {
              const text = node.textContent || '';
              if (text.length < 1000 && text.toLowerCase().includes('added to cart')) {
                targetNode = node;
                break;
              }
            }
          }
        } else if (m.type === 'attributes' || m.type === 'characterData') {
          let node = m.target;
          if (node.nodeType === 3) node = node.parentElement;
          if (node) {
            const text = node.textContent || '';
            if (text.length < 1000 && text.toLowerCase().includes('added to cart')) {
              targetNode = node;
            }
          }
        }
        
        if (targetNode) {
          let container = targetNode;
          while (container && container !== document.body && container !== document.documentElement) {
            const style = window.getComputedStyle(container);
            if (style.position === 'fixed' || style.position === 'absolute' || parseInt(style.zIndex) >= 100) {
              if (!container.classList.contains('cstm-repositioned-toast')) {
                container.classList.add('cstm-repositioned-toast');
              }
              break;
            }
            container = container.parentElement;
          }
        }
      }
    });

    toastObserver.observe(document.body, { childList: true, subtree: true, attributes: true, characterData: true, attributeFilter: ['class', 'style'] });
    
    setTimeout(() => {
      if (toastObserver) {
        toastObserver.disconnect();
        toastObserver = null;
      }
    }, 3000);
  }

  // Start observer immediately on any click to catch optimistic UI popups before paint
  document.addEventListener('click', function(e) {
    let t = e.target;
    while(t && t !== document) {
      if(t.tagName === 'BUTTON' || t.tagName === 'A') {
        startToastObserver();
        break;
      }
      t = t.parentNode;
    }
  }, true);

  // Global fetch interceptor to catch any cart modifications
  const originalFetch = window.fetch;
  window.fetch = function() {
    const url = arguments[0];
    if (typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/change'))) {
      startToastObserver();
    }
    return originalFetch.apply(this, arguments).then(res => {
      if (typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear'))) {
        res.clone().json().then(() => {
          fetchAndCheckCart();
        }).catch(e => {});
      }
      return res;
    });
  };

  // jQuery global interceptor for themes using $.ajax
  if (window.jQuery) {
    window.jQuery(document).ajaxSend(function(event, jqXHR, settings) {
      if (settings.url && (settings.url.includes('/cart/add') || settings.url.includes('/cart/change'))) {
        startToastObserver();
      }
    });
    window.jQuery(document).ajaxSuccess(function(event, xhr, settings) {
      if (settings.url && (settings.url.includes('/cart/add') || settings.url.includes('/cart/change') || settings.url.includes('/cart/update') || settings.url.includes('/cart/clear'))) {
        fetchAndCheckCart();
      }
    });
  }

  let updateTimeout;
  const observer = new MutationObserver(function(mutations) {
    let shouldUpdate = false;
    for (let m of mutations) {
      if (m.addedNodes.length > 0 || m.type === 'characterData' || (m.type === 'attributes' && m.attributeName !== 'data-original-html' && m.attributeName !== 'data-cart-redirect-bound')) {
        shouldUpdate = true;
        break;
      }
    }
    if (shouldUpdate && currentCartItems.length > 0) {
      clearTimeout(updateTimeout);
      updateTimeout = setTimeout(() => {
        updateAllCartButtons();
      }, 50);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true, attributes: true, characterData: true, attributeFilter: ['class', 'type', 'disabled'] });

  // Quantity selector pill logic & live AJAX cart sync
  document.addEventListener('click', function(e) {
    const minusBtn = e.target.closest('.card-qty-minus, .foxtale-sticky-qty-minus, .product-form__qty-btn--minus, .mobile-sticky-qty-btn--minus');
    const plusBtn = e.target.closest('.card-qty-plus, .foxtale-sticky-qty-plus, .product-form__qty-btn--plus, .mobile-sticky-qty-btn--plus');
    
    if (!minusBtn && !plusBtn) return;
    e.preventDefault();
    e.stopPropagation();

    const clickedBtn = minusBtn || plusBtn;
    const isPlus = Boolean(plusBtn);

    // Find container and variant ID
    const container = clickedBtn.closest('.product-item, .meta-product-item, .product-card, .foxtale-sticky-form-wrap, .product-form__cta-row, .mobile-sticky-atc__container, form, .product-form, .product-sticky-form') || clickedBtn.parentElement;
    let variantId = null;
    if (container) {
      variantId = getVariantId(container);
      if (!variantId) {
        const idInput = container.querySelector('input[name="id"], select[name="id"]');
        if (idInput) variantId = idInput.value;
      }
    }
    if (!variantId) {
      const fallbackForm = document.querySelector('form[action*="/cart/add"], form[data-cart-form="true"], .foxtale-sticky-form-wrap');
      if (fallbackForm) {
        const idInput = fallbackForm.querySelector('input[name="id"]');
        if (idInput) variantId = idInput.value;
      }
    }
    if (!variantId) return;

    // Find current cart quantity for this variant
    const cartItem = currentCartItems.find(item => String(item.variant_id || item.id) === String(variantId));
    const qtyInput = container ? container.querySelector('input[name="quantity"], .foxtale-sticky-qty-val, .product-form__qty-val, [data-sticky-qty], .card-qty-val, [data-card-qty]') : null;
    
    let currentQty = cartItem ? cartItem.quantity : parseInt(qtyInput ? (qtyInput.value || qtyInput.textContent || 1) : 1) || 1;
    let newQty = isPlus ? currentQty + 1 : currentQty - 1;
    if (newQty < 0) newQty = 0;

    // Optimistic UI update
    const allMatchingInputs = document.querySelectorAll('input[name="quantity"], .foxtale-sticky-qty-val, .product-form__qty-val');
    allMatchingInputs.forEach(el => {
      if (el.tagName === 'INPUT') el.value = newQty;
      else el.textContent = newQty;
    });
    document.querySelectorAll('[data-sticky-qty]').forEach(el => el.textContent = newQty);

    // Update all matching card quantity pills on page
    const matchingCards = document.querySelectorAll('.product-item, .meta-product-item, .product-card, .cstm-prd-lst');
    matchingCards.forEach(card => {
      const vId = getVariantId(card) || card.querySelector('input[name="id"]')?.value;
      if (String(vId) === String(variantId)) {
        const cPill = card.querySelector('.card-qty-pill, [data-card-qty-pill]');
        const cBtn = card.querySelector('.product-item__cta, .product-card__cta');
        const cVal = card.querySelector('.card-qty-val, [data-card-qty]');
        if (cPill && cBtn) {
          if (newQty > 0) {
            cBtn.style.setProperty('display', 'none', 'important');
            cPill.style.setProperty('display', 'flex', 'important');
            if (cVal) cVal.textContent = newQty;
          } else {
            cPill.style.setProperty('display', 'none', 'important');
            cBtn.style.removeProperty('display');
            if (cVal) cVal.textContent = '1';
          }
        }
      }
    });

    // If PDP quantity reaches 0, optimistically hide PDP pill and revert button
    if (newQty === 0) {
      const pill = clickedBtn.closest('.foxtale-sticky-qty-pill, .product-form__qty-selector, .mobile-sticky-atc__qty-box');
      if (pill) pill.style.setProperty('display', 'none', 'important');
      const btn = container ? container.querySelector('button.go-to-cart-btn, .foxtale-sticky-atc, #AddToCart') : null;
      if (btn) {
        btn.classList.remove('go-to-cart-btn');
        btn.setAttribute('type', 'submit');
        btn.innerHTML = btn.getAttribute('data-original-html') || 'Add to Cart';
      }
    }

    // Perform live AJAX update with Shopify Cart API
    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + 'cart/change.js' : '/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: String(variantId),
        quantity: newQty
      })
    })
    .then(res => res.json())
    .then(cart => {
      // Update global state & all UI buttons/pills
      updateAllCartButtons(cart.items);

      // Update cart count bubbles in header
      const countElements = document.querySelectorAll('cart-count, .cart-count, .bubble-count, .header__cart-count, .item-count, #cart-count a:first, #gocart p a, #cart .checkout em');
      countElements.forEach(el => {
        el.textContent = cart.item_count;
      });

      // Dispatch Shopify theme events so mini-cart drawer re-renders
      try {
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
      } catch (err) {}
    })
    .catch(err => {
      console.error('Error changing cart quantity:', err);
      fetchAndCheckCart();
    });
  });
});
